import { authHttp, responseOk, responseError } from '../axios-client'
import _ from 'lodash'

export async function fetchGetMyStakingDeposits(accessToken, isSSR = false) {
  return await authHttp(isSSR, { accessToken })
    .get(`explorer/auth/early-staking`)
    .then((res) => responseOk(res))
    .catch((err) => responseError(err))
}

export async function fetchGetMyStakingDeposit(accessToken, programId, isSSR = false) {
  return await authHttp(isSSR, { accessToken })
    .get(`explorer/auth/early-staking/${programId}`)
    .then((res) => responseOk(res))
    .catch((err) => responseError(err))
}

export async function fetchGetMyStakingDepositHistory(accessToken, programId, isSSR = false) {
  return await authHttp(isSSR, { accessToken })
    .get(`explorer/auth/early-staking/${programId}/deposit-history?page=${page}&size=30`)
    .then((res) => responseOk(res))
    .catch((err) => responseError(err))
}

export async function fetchGetMyStakingClaimHistory(accessToken, programId, page, isSSR = false) {
  return await authHttp(isSSR, { accessToken })
    .get(`explorer/auth/early-staking/${programId}/claim-history?page=${page}&size=30`)
    .then((res) => responseOk(res))
    .catch((err) => responseError(err))
}

export async function stakingProgramDeposit(accessToken, programId, body, isSSR = false) {
  return await authHttp(isSSR, { accessToken })
    .post(`explorer/auth/early-staking/${programId}/deposit`, body)
    .then((res) => responseOk(res))
    .catch((err) => responseError(err))
}

export async function stakingProgramWithdraw(accessToken, programId, body, isSSR = false) {
  return await authHttp(isSSR, { accessToken })
    .post(`explorer/auth/early-staking/${programId}/withdraw`, body)
    .then((res) => responseOk(res))
    .catch((err) => responseError(err))
}

export async function stakingProgramClaim(accessToken, programId, isSSR = false) {
  return await authHttp(isSSR, { accessToken })
    .post(`explorer/auth/early-staking/${programId}/claim`, {})
    .then((res) => responseOk(res))
    .catch((err) => responseError(err))
}
